import {EventRenderRange} from "@fullcalendar/react";
import EventSummaryItem from "../../../stores/domainStore/pages/models/eventSummaryItem";
import {Col, Container, Row} from "reactstrap";
import EventSummaryDayColumn from "../eventSummaryDayColumn/eventSummaryDayColumn";
import React from "react";
import {
  checkDatesEqual,
  isDateOneSameOrAfterDateTwo
} from "../../../utils/dateUtils";
import classNames from "classnames";

export interface IEventSummaryCalendarViewProps {
  leftHandDate: Date;
  rightHandDate: Date;
  startDate?: Date;
  endDate?: Date;
  segments: EventRenderRange[];
  onEventClick: (event: EventSummaryItem) => void;
  isMultiVillageOptionSelected?: boolean;
  timeZone: string;
}

const EventSummaryCalendarView: React.FC<IEventSummaryCalendarViewProps> = ({
  leftHandDate,
  rightHandDate,
  startDate,
  endDate,
  segments,
  onEventClick,
  isMultiVillageOptionSelected,
  timeZone
}) => {
  function toEventItem(seg: EventRenderRange) {
    return new EventSummaryItem(
      seg.def.publicId,
      new Date(
        seg.range.start.getUTCFullYear(),
        seg.range.start.getUTCMonth(),
        //without using getUTC we are experiencing a conversion to UTC from local
        seg.range.start.getUTCDate(),
        seg.range.start.getUTCHours(),
        seg.range.start.getUTCMinutes(),
        seg.range.start.getUTCSeconds()
      ),
      new Date(
        seg.range.end.getUTCFullYear(),
        seg.range.end.getUTCMonth(),
        seg.range.end.getUTCDate(),
        seg.range.end.getUTCHours(),
        seg.range.end.getUTCMinutes(),
        seg.range.end.getUTCSeconds()
      ),
      seg.def.title,
      seg.def.extendedProps["location"],
      timeZone,
      seg.def.allDay,
      seg.def.extendedProps.isBookableEvent,
      seg.def.extendedProps.capacityRemaining,
      seg.def.extendedProps.reservedCapacityRemaining,
      seg.def.extendedProps.isFeaturedEvent,
      seg.def.extendedProps.capacity,
      seg.def.extendedProps.isMultiVillageEvent,
      seg.def.extendedProps.eventStatus,
      seg.def.extendedProps["eventRecurrenceDetails"],
      seg.def.extendedProps["recurringStatus"],
      seg.def.extendedProps["eventStartDateTimeOffSet"],
      seg.def.extendedProps.releaseDate
    );
  }

  let leftHandEvents = segments
    .filter((seg) => leftHandDate.getDate() === seg.range.start.getUTCDate())
    .map((seg) => toEventItem(seg));

  let rightHandEvents = segments
    .filter((seg) => rightHandDate.getDate() === seg.range.start.getUTCDate())
    .map((seg) => toEventItem(seg));

  let isUnreleased = checkDatesEqual(startDate, rightHandDate);
  let isReleaseFutureDateRight =
    (startDate && isDateOneSameOrAfterDateTwo(rightHandDate, startDate)) ||
    false;
  let isReleaseFutureDateLeft =
    (startDate && isDateOneSameOrAfterDateTwo(leftHandDate, startDate)) ||
    false;
  let isFutureUnreleasedRight = isDateOneSameOrAfterDateTwo(
    rightHandDate,
    endDate
  );
  let isFutureUnreleasedLeft = isDateOneSameOrAfterDateTwo(
    leftHandDate,
    endDate
  );

  if (isMultiVillageOptionSelected) {
    isUnreleased = false;
    isReleaseFutureDateRight = false;
    isReleaseFutureDateLeft = false;
    isFutureUnreleasedRight = true;
    isFutureUnreleasedLeft = true;
  }

  return (
    <Container style={{padding: 0}} fluid>
      <Row noGutters>
        {/* left hand */}
        <Col
          xs={6}
          className={classNames("leftHandSummaryDayColumn", {
            "unreleased-header-background-summary": isReleaseFutureDateLeft
          })}
        >
          <EventSummaryDayColumn
            dayDate={leftHandDate}
            events={leftHandEvents}
            isReleaseDate={isReleaseFutureDateLeft}
            onEventClick={onEventClick}
            isFutureReleaseDate={isFutureUnreleasedLeft}
            calendarScheduleStartDate={startDate}
          />
        </Col>
        {/* right hand */}
        <Col
          xs={6}
          className={classNames({
            "unreleased-border-left": isUnreleased,
            "unreleased-header-background-summary": isReleaseFutureDateRight
          })}
        >
          <EventSummaryDayColumn
            dayDate={rightHandDate}
            events={rightHandEvents}
            isReleaseDate={isReleaseFutureDateRight}
            onEventClick={onEventClick}
            isFutureReleaseDate={isFutureUnreleasedRight}
            calendarScheduleStartDate={startDate}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default EventSummaryCalendarView;
